import Countries from "@utils/constants/county";
import { deliveryTypesForUiFilter } from "@utils/constants/DeliveryType/deliveryTypeAttributes";
import { z } from "zod";

const DeliveryFilterSchema = z.object({
  deliveryCountries: z
    .object(
      Object.values(Countries).reduce<Record<string, z.ZodDefault<z.ZodBoolean>>>(
        (acc, country) => {
          acc[country.code] = z.boolean().default(false);
          return acc;
        },
        {}
      )
    )
    .nullish(),
  deliveryType: z
    .object(
      deliveryTypesForUiFilter.reduce<Record<string, z.ZodDefault<z.ZodBoolean>>>((acc, type) => {
        acc[type] = z.boolean().default(false);
        return acc;
      }, {})
    )
    .nullish(),
  deliveryServices: z.record(z.string(), z.boolean()).nullish(),
  organizationSlug: z.array(z.string()).nullish().default([]),
  carDeliveryDeadlineFrom: z.date().nullish().default(null),
  carDeliveryDeadlineTo: z.date().nullish().default(null),
});

export default DeliveryFilterSchema;
export type DeliveryFilterSchemaType = z.infer<typeof DeliveryFilterSchema>;
export const DeliveryFilterDefaultValues = {
  deliveryCountries: Object.values(Countries).reduce<Record<string, boolean>>((acc, country) => {
    acc[country.code] = false;
    return acc;
  }, {}),
  deliveryType: deliveryTypesForUiFilter.reduce<Record<string, boolean>>((acc, type) => {
    acc[type] = false;
    return acc;
  }, {}),
  deliveryServices: {},
  organizationSlug: [],
  carDeliveryDeadlineFrom: null,
  carDeliveryDeadlineTo: null,
};
